import './styles/App.css';
import { Route, Routes } from 'react-router-dom';
import { Home, Product, LandingProduct, Order } from './pages';
import ReactPixel from 'react-facebook-pixel';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import useStore from './store/useStore';
import { useGeolocated } from "react-geolocated";
import { Helmet } from 'react-helmet';

import './lib/i18n';
import { useTranslation } from 'react-i18next';
import { DirectionProvider, useDirection } from '@mantine/core';

const cookies = new Cookies(null, { path: '/' });

function App() {
    const { i18n } = useTranslation();
    const { toggleDirection, dir, setDirection } = useDirection();
    const dataStore = useStore((state: any) => state.store);

    useEffect(() => {
        if(cookies.get('lang')) {
          setDirection(i18n.dir(cookies.get('lang')))
          i18n.changeLanguage(cookies.get('lang'));
        } else {
          setDirection(i18n.dir("ar"))
          i18n.changeLanguage("ar");
        }
    
        if (i18n.dir() === "rtl") {
          if (document) {
            //@ts-ignore
            document.querySelector("html").setAttribute("dir", "rtl")
          }
        }
    }, [cookies.get('lang')])
    
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/store`)
        .then(({data}) => {
            // cookies.set('store', JSON.stringify(dataStore));
            useStore.setState({ store: data });
        })
        .catch((error) => {
            console.log(error);
        })
    }, [])
    
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/pixels`)
        .then(({data}) => {
            // const facebookData = data.filter((item: any) => item.name === "facebook")
            // console.log(facebookData);
            // setFacebookToken(facebookData?.[0]?.apiKey)
            const advancedMatching = undefined;
            data?.map((item: any, index: number) => {
                if (item?.apiKey !== "" && item?.apiKey.length > 10) {
                    ReactPixel.init(item?.apiKey, advancedMatching, {
                        autoConfig: true,
                        debug: true
                    });
                }
            })
            ReactPixel.pageView();
        })
        .catch((error) => console.log(error));
    }, [])

    // useEffect(() => {
    //     if (facebookToken !== "") {
    //         ReactPixel.init(facebookToken);
    //         ReactPixel.pageView();
    //         // ReactPixel.track()
    //     }
    // }, [facebookToken])

    return (
        <>
            <Helmet>
                <link rel="icon" href={dataStore?.icon && dataStore?.icon !== "" ? `${process.env.REACT_APP_API_URL_IMAGES}/${dataStore?.icon}` : "/favicon.ico"} />
                <title>{dataStore?.information?.title || ""}</title>
                <meta name="description" content={dataStore?.information?.shortDescription || ""} />
            </Helmet>
            <DirectionProvider i18nIsDynamicList={true} initialDirection={i18n.dir()}>
                <Routes>
                    <Route index path="/" element={<Home />} />
                    <Route index path="/product/:id" element={<Product />} />
                    <Route index path="/:id" element={<LandingProduct />} />
                    <Route index path="/order/:status/:type?/:id?/:isMany?" element={<Order />} />
                </Routes>
            </DirectionProvider>
        </>
    );
}

export default App;
